import React from "react";
import { HomePage } from "./home.js";
import {replaceAllStoriesInCollection} from '@quintype/components';

class HomePagePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      started: false,
      data: props.data,
      preview: true
    };
  }

  componentDidMount() {
    this.collectStoryData();
  }

  collectStoryData() {
    global.addEventListener("message", (event) => {
      if (event.data.story) {
        this.setState({
          started: true,
          data: Object.assign({}, this.props.data, {
            collection: replaceAllStoriesInCollection(this.props.data.collection, event.data.story)
          })
        })
      }
    });
  }

  render() {
    if(!this.state.started) return <div/>;
    return <HomePage data={this.state.data}/>
  }
}

export { HomePagePreview };
